import { API_BASE_URL } from '../config/env';

const UNSAFE_METHODS = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

function getCookie(name) {
  return document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${name}=`))
    ?.split('=')
    .slice(1)
    .join('=');
}

export function apiFetch(path, options = {}) {
  const method = (options.method || 'GET').toUpperCase();
  const headers = { ...(options.headers || {}) };
  const isFormData = options.body instanceof FormData;

  if (!isFormData && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }

  if (UNSAFE_METHODS.has(method)) {
    const csrfToken = getCookie('csrf_token');
    if (csrfToken) {
      headers['X-CSRF-Token'] = decodeURIComponent(csrfToken);
    }
  }

  return fetch(`${API_BASE_URL}${path}`, {
    ...options,
    method,
    headers,
    credentials: 'include',
  });
}

export async function buildApiError(response, fallbackMessage = 'Request failed') {
  const contentType = response.headers?.get?.('content-type') || '';
  let detail = null;
  let message = fallbackMessage;

  try {
    if (contentType.includes('application/json')) {
      const body = await response.json();
      detail = body?.detail ?? body?.error ?? body;
      if (typeof detail === 'string') {
        message = detail;
      } else if (detail?.message) {
        message = detail.message;
      } else if (body?.message) {
        message = body.message;
      }
    } else {
      const text = await response.text();
      detail = text;
      if (text) message = text;
    }
  } catch (_) {
    // Keep fallback message when response parsing fails.
  }

  const error = new Error(message || fallbackMessage);
  error.status = response.status;
  error.statusText = response.statusText;
  error.detail = detail;
  if (detail?.code) error.code = detail.code;
  return error;
}
